import { fetchSystemConstants } from '../services/systemConstantsService.js';

export const FETCH_SYSTEM_CONSTANTS_REQUEST = 'FETCH_SYSTEM_CONSTANTS_REQUEST';
export const FETCH_SYSTEM_CONSTANTS_SUCCESS = 'FETCH_SYSTEM_CONSTANTS_SUCCESS';
export const FETCH_SYSTEM_CONSTANTS_FAILURE = 'FETCH_SYSTEM_CONSTANTS_FAILURE';

export const fetchSystemConstantsAction = (token) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_SYSTEM_CONSTANTS_REQUEST });
        
        try {
            const constants = await fetchSystemConstants(token);
            dispatch({
                type: FETCH_SYSTEM_CONSTANTS_SUCCESS,
                payload: constants
            });
            return constants;
        } catch (error) {
            dispatch({
                type: FETCH_SYSTEM_CONSTANTS_FAILURE,
                payload: error.message
            });
            throw error;
        }
    };
};
